import { Button } from "..";
import "./notFoundCard.css";

export const NotFoundCard = ({
	title = "Not Found",
	message = "The link you followed does not match any record in the system. Please check the link and try again.",
	onBack
}) => (
	<section className="rse-not-found-card">
		<div className="rse-not-found-card__icon">✕</div>
		<h1>{title}</h1>
		<p>{message}</p>
		<hr className="rse-not-found-card__divider" />
		<Button label="Back" buttonClass="standard" onClick={onBack} />
	</section>
);
